<template>
  <v-container fluid>
    <v-row align="center" mt="4" v-if="loader">
      <v-skeleton-loader
        transition-group="fade-transition"
        type="table, table-tfoot"
      ></v-skeleton-loader>
    </v-row>
    <v-row align="center" mt="4" v-else>
      <v-data-table
        :headers="tableheaders"
        :items="substances"
        :items-per-page="5"
        class="elevation-8"
        :footer-props="{
          'items-per-page-text': `${$t('generic.LinePerPage')}`,
          'items-per-page-all-text': `${$t('generic.All')}`,
        }"
        :no-data-text="`${$t('generic.noFav')}`"
      >
        <template v-slot:top>
          <v-container fluid>
            <h1 class="text-h6 mx-4">{{ $t("export.selection") }} :</h1>
            <v-toolbar flat :height="toolbar_height">
              <v-row>
                <v-btn
                  class="mx-4 my-1"
                  depressed
                  color="secondary"
                  :disabled="mySearchIsSelect"
                  @click="selectMySearch()"
                >
                  {{ $t("export.mysearch") }}
                </v-btn>
                <v-btn
                  class="mx-4 my-1"
                  depressed
                  color="secondary"
                  :disabled="headersSelected === headersNoEmptyRules"
                  @click="selectNoEmptyRules()"
                >
                  {{ $t("export.concern") }}
                </v-btn>
                <v-btn
                  class="mx-4 my-1"
                  depressed
                  color="secondary"
                  :disabled="headersSelected === headersAllRules"
                  @click="selectAllRules()"
                >
                  {{ $t("export.all") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <table-export-fct
                  :listeSubstances="dataToExport.substances"
                  :listeRules="dataToExport.rules"
                >
                  {{ $t("generic.export") }}
                </table-export-fct>
              </v-row>
            </v-toolbar>
            <v-divider class="mx-4 mb-2"></v-divider>
            <v-autocomplete
              class="mx-4"
              :items="headers"
              v-model="headersSelected"
              return-object
              :label="$t('export.custom')"
              multiple
              chips
              small-chips
              clearable
              deletable-chips
            ></v-autocomplete>
          </v-container>
        </template>
        <template v-slot:[`item.substance`]="{ item }">
          <v-container class="mx-0 my-2 pa-0">
            <v-row>
              <v-col style="width: 250px">
                <div class="text-body-1">{{ item.substance.name }}</div>
                <div class="text-body-2">N°CE : {{ item.substance.ce }}</div>
                <div class="text-body-2">N°CAS : {{ item.substance.cas }}</div>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:[`footer.page-text`]="items">
          {{ items.pageStart }} - {{ items.pageStop }} {{ $t("generic.of") }}
          {{ items.itemsLength }}
        </template>
      </v-data-table>
    </v-row>
  </v-container>
</template>

<script>
import TableExportFct from "./TableExportFct.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      Mainheaders: [
        {
          text: "Substance",
          value: "substance",
        },
      ],
      headers: [],
      substances: [],
      headersSelected: [],
      allRules: [],
      headersAllRules: [],
      headersNoEmptyRules: [],
      loader: false,
      // export
      dataToExport: {
        rules: [],
        substances: [],
      },
      headersMySearch: [],
      substancesToAnalyse: [],
    };
  },
  computed: {
    tableheaders() {
      return [...this.Mainheaders, ...this.headersSelected];
    },
    ...mapGetters(["multiRulesSelection", "currentPage"]),
    mySearchIsSelect() {
      if (
        this.headersSelected === this.headersMySearch ||
        this.headersMySearch.length === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    toolbar_height() {
      let height = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          height = "200px";
          break;
        case "sm":
          height = "100px";
          break;
        case "md":
          height = "";
          break;
        case "lg":
          height = "";
          break;
        case "xl":
          height = "";
          break;
      }
      return height;
    },
  },
  components: {
    TableExportFct,
  },
  methods: {
    ...mapMutations(["setCurrentPage"]),
    populateHeaders() {
      if (this.headersMySearch.length) {
        this.headersSelected = this.headersMySearch;
      } else {
        this.headersSelected = this.headersNoEmptyRules;
      }
    },
    async fetchAllRules() {
      var request = {
        method: "GET",
        url: "/rules",
      };
      try {
        var response = await this.axios(request);
        this.loader = true;
        this.allRules = response.data;
        let ruleVSId = {};
        this.allRules.forEach((rule) => {
          ruleVSId[rule.usual_name] = rule._id;
        });

        let rules = [...this.allRules];

        // // test of many text
        // for (let index = 0; index < 80; index++) {
        //   let rule = { usual_name: `texte ${index}`, substances: [] };
        //   rules.push(rule);
        // }
        // // end

        this.headersAllRules = rules.map((rule) => {
          if (this.multiRulesSelection.indexOf(rule._id) >= 0) {
            this.headersMySearch.push({
              text: rule.usual_name,
              value: rule.usual_name,
              id: rule._id,
            });
          }
          return {
            text: rule.usual_name,
            value: rule.usual_name,
            id: rule._id,
          };
        });
        this.headers = [...this.headersAllRules];

        let sub = this.substancesToAnalyse;

        let countRules = {};
        let rulesNames = rules.map((rule) => {
          countRules[rule.usual_name] = 0;
          return rule.usual_name;
        });

        this.headersNoEmptyRules = [];
        // format substances for table value
        this.substances = sub.map((s) => {
          let substance = { substance: s.substance };
          s.rulesNames.forEach((name) => {
            if (rulesNames.indexOf(name) < 0) {
              substance[name] = "";
            } else {
              substance[name] = "X";
              countRules[name] += 1;
            }
          });
          return substance;
        });
        for (const [key, value] of Object.entries(countRules)) {
          if (value > 0) {
            this.headersNoEmptyRules.push({
              text: key,
              value: key,
              id: ruleVSId[key],
            });
          }
        }

        this.populateHeaders();
        this.loader = false;
      } catch (err) {
        console.log(err);
      }
    },
    selectNoEmptyRules() {
      this.headersSelected = this.headersNoEmptyRules;
    },
    selectAllRules() {
      this.headersSelected = this.headersAllRules;
    },
    selectMySearch() {
      this.headersSelected = this.headersMySearch;
    },
    setData() {
      let ruleIDs = this.headersSelected.map((rule) => {
        return rule.id;
      });
      this.dataToExport.rules = ruleIDs;
      let subIDs = this.substances.map((sub) => {
        return sub.substance.id;
      });
      this.dataToExport.substances = subIDs;
    },
  },
  beforeMount() {
    if (this.currentPage.name === this.$route.name) {
      this.substancesToAnalyse = this.currentPage.params.substances;
    } else {
      this.substancesToAnalyse = this.$route.params.substances;
      this.setCurrentPage({
        name: this.$route.name,
        params: this.$route.params,
      });
    }
    this.fetchAllRules();
  },
  watch: {
    headersSelected() {
      this.setData();
    },
  },
};
</script>
